document.addEventListener("DOMContentLoaded", function () {
  function runOnMobile() {
    if (window.matchMedia("(max-width: 767px)").matches) {
      console.log("This code runs only on mobile devices.");

      document.querySelectorAll(".\\#footer .\\#footer-heading:not(.footer-heading-social)").forEach(heading => {
        heading.addEventListener("click", (event) => {
          const currentTarget = event.currentTarget;
          currentTarget.classList.toggle("active");
          const nextElement = currentTarget.nextElementSibling;
          if (nextElement) {
            if (nextElement.style.display === "none" || nextElement.style.display === "") {
              nextElement.style.display = "block";
            } else {
              nextElement.style.display = "none";
            }
          }
        });
      });
    }
  }

  runOnMobile();
  window.addEventListener("resize", runOnMobile);
  

  
});
